/**
 * Default debounce delay for search inputs (in milliseconds).
 * Used to prevent excessive URL updates while typing.
 */
export const SEARCH_DEBOUNCE_MS = 400;

/**
 * Desktop breakpoint (matches Tailwind's `lg`). At or above this width the
 * sidebar reflows inline (rail/full) and the agent panel docks to the side;
 * below it the sidebar becomes a drawer and the agent panel goes fullscreen.
 */
export const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

/**
 * Mobile breakpoint (below Tailwind's `md`). Below this width, overlay
 * components that would be cramped in a popover (date pickers) present as a
 * bottom sheet instead.
 */
export const MOBILE_MEDIA_QUERY = '(max-width: 767px)';

/** Set when the reader has asked the system to minimise animation. */
export const REDUCED_MOTION_MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
